import React from 'react';
import NavigationPrompt from 'react-router-navigation-prompt';
import UnsavedChangesModal from './UnsavedChangesModal';
import MicroFrontendEventManager from '../../../../../microfrontend-events/MicroFrontendEventManager';

interface NavigationBlockPromptManagerState {
  shouldBlock: boolean;
}

class NavigationBlockPromptManager extends React.Component<{}, NavigationBlockPromptManagerState> {
  state: NavigationBlockPromptManagerState = {
    shouldBlock: false
  };

  private readonly SHOULD_BLOCK_NAVIGATION_EVENT = 'should-block-navigation';

  private readonly RESTORES_VALUES_EVENT = 'restore-values';

  componentDidMount() {
    MicroFrontendEventManager.subscribe(
      this.SHOULD_BLOCK_NAVIGATION_EVENT,
      this.handleShouldBlockNavigationEvent as EventListener
    );
  }

  componentWillUnmount() {
    MicroFrontendEventManager.unsubscribe(
      this.SHOULD_BLOCK_NAVIGATION_EVENT,
      this.handleShouldBlockNavigationEvent as EventListener
    );
  }

  handleShouldBlockNavigationEvent = (event: Event) => {
    const { detail } = event as CustomEvent;
    const { shouldBlock: eventShouldBlock } = detail;
    const { shouldBlock } = this.state;
    if (eventShouldBlock !== shouldBlock) {
      this.setState({ shouldBlock: eventShouldBlock });
    }
  };

  handleOnContinue = (onConfirm: () => void) => {
    this.setState({ shouldBlock: false });
    MicroFrontendEventManager.dispatch(this.RESTORES_VALUES_EVENT);
    onConfirm();
  };

  render() {
    const { shouldBlock } = this.state;
    return (
      <NavigationPrompt when={shouldBlock}>
        {({ onConfirm, onCancel }) => (
          <UnsavedChangesModal
            isOpen={shouldBlock}
            onClose={() => onCancel()}
            onContinue={() => this.handleOnContinue(onConfirm)}
          />
        )}
      </NavigationPrompt>
    );
  }
}

export default NavigationBlockPromptManager;
